var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { v4 as uuid } from 'uuid';
export class SoundFileInstrument {
    static create(context, settings = SoundFileInstrument.createDefaults()) {
        return __awaiter(this, void 0, void 0, function* () {
            const o = new SoundFileInstrument(context, settings);
            yield o.initialise();
            return o;
        });
    }
    constructor(context, settings = SoundFileInstrument.createDefaults()) {
        this._settings = settings;
        this.id = uuid();
        this._context = context;
        this._playingNodes = [];
        this._masterGain = context.createGain();
        this._masterGain.gain.value = this._settings.gain;
    }
    initialise() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._settings.soundData != "") {
                this._audioBuffer = yield this._context.decodeAudioData(yield SoundFileInstrument.getBlobFromBase64(this._settings.soundData).arrayBuffer());
            }
        });
    }
    get duration() {
        if (this._audioBuffer != null) {
            return this._audioBuffer.duration;
        }
        else {
            return 0;
        }
    }
    get masterGain() {
        return this._masterGain.gain.value;
    }
    set masterGain(value) {
        if (!(value >= 0 && value <= 1)) {
            throw new RangeError("Invalid Gain Value");
        }
        this._settings.gain = value;
        this._masterGain.gain.setValueAtTime(value, this._context.currentTime);
    }
    connect(node) {
        if (node instanceof AudioNode) {
            this._masterGain.connect(node);
        }
        else {
            this._masterGain.connect(node.input);
        }
    }
    disconnect(node) {
        if (node instanceof AudioNode) {
            this._masterGain.disconnect(node);
        }
        else {
            this._masterGain.disconnect(node.input);
        }
    }
    disconnectAll() {
        this._masterGain.disconnect();
    }
    playOneShot(startTime, offset, volume = 1) {
        let bufferSource = SoundFileInstrument.createBufferSource(this._context, this._audioBuffer);
        this._playingNodes.push(bufferSource);
        if (volume != 1) {
            let volumeGain = this._context.createGain();
            volumeGain.gain.value = volume;
            bufferSource.connect(volumeGain);
            volumeGain.connect(this._masterGain);
        }
        else {
            bufferSource.connect(this._masterGain);
        }
        if (offset < 0) {
            offset = 0;
        }
        startTime = Math.max(0, startTime);
        bufferSource.start(startTime, offset);
    }
    stop() {
        this._playingNodes.forEach(bufferSource => {
            bufferSource.stop();
        });
        this._playingNodes = [];
    }
    setSoundFile(file) {
        return __awaiter(this, void 0, void 0, function* () {
            SoundFileInstrument.getBase64FromBlob(file, base64 => {
                this._settings.soundData = base64;
            });
            this._audioBuffer = yield this._context.decodeAudioData(yield file.arrayBuffer());
        });
    }
    serialise() {
        return this._settings;
    }
    destroy() {
        this._masterGain = null;
        this._playingNodes = [];
        this._audioBuffer = null;
    }
    static createBufferSource(context, buffer) {
        let bufferSource = context.createBufferSource();
        bufferSource.buffer = buffer;
        return bufferSource;
    }
    static getBase64FromBlob(file, callback) {
        let reader = new FileReader();
        reader.onload = function () {
            callback(reader.result);
        };
        reader.readAsDataURL(file);
    }
    static getBlobFromBase64(base64blob) {
        var byteString = atob(base64blob.split(',')[1]);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: base64blob.split(":").pop().split(";")[0] });
    }
    static createDefaults() {
        return {
            "type": "soundFile",
            "gain": 1,
            "soundData": ""
        };
    }
}
//# sourceMappingURL=SoundFileInstrument.js.map